import { Route } from '@angular/router';

import { awardsRoutes } from './awards.routes';
import { googleProfileRoutes } from './google-profile.routes';
import { socialMediaRoutes } from './social-media.routes';

export const shareRoutes: Route[] = [
  {
    path: 'awards',
    children: awardsRoutes,
  },
  {
    path: 'google-profile',
    children: googleProfileRoutes,
  },
  {
    path: 'market-reports',
    loadChildren: () => import('@rma/market-reports/market-reports'),
  },
  {
    path: 'integrations',
    loadChildren: () => import('@rma/integrations/integration-hub'),
  },
  {
    path: 'socialmedia',
    children: socialMediaRoutes,
  },
  {
    path: 'widgets',
    loadChildren: () => import('@rma/integrations/widgets'),
  },
];
